import api from "@/plugins/api";
import institutionLoginApi from "@/plugins/api/institution/login";

/**
 * 正式环境域名映射
 * SMO 平台：smo 角色 → smo.yscro.com，申办方/CRO 角色 → yesmo.yscro.com
 */
const PROD_URLS = {
  smo: "https://smo.yscro.com",
  sponsor: "https://yesmo.yscro.com",
  agent: "https://agent.yscro.com",
};

/**
 * 根据当前域名推导子系统地址
 * 规则：{env}-yscro-shop-gate.gooclin.com → {env}-yscro-shop-{app}.gooclin.com
 * env 前缀支持 test- / dev- / pre-，无前缀则为正式环境
 * 匹配不到时兜底使用正式域名
 */
function getAppUrl(appName) {
  const hostname = window.location.hostname;
  const match = hostname.match(
    /^((?:test|dev|pre)-)?yscro-shop-gate\.gooclin\.com$/
  );
  if (match) {
    const prefix = match[1] || "";
    const port = prefix === "pre-" ? ":1443" : "";
    return `https://${prefix}yscro-shop-${appName}.gooclin.com${port}`;
  }
  // 本地开发
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const fallback = {
      sponsor: "http://localhost:8011",
      smo: "http://localhost:8012",
      agent: "https://test-yscro-shop-agent.gooclin.com",
    };
    return fallback[appName] || PROD_URLS[appName] || "/";
  }
  // 匹配不到，兜底正式域名
  return PROD_URLS[appName] || "/";
}

const INSTITUTION_APP_URL =
  process.env.VUE_APP_INSTITUTION_URL || "https://mall.yscro.com";

const state = {
  loading: false,
};

const mutations = {
  SET_LOADING(state, val) {
    state.loading = val;
  },
};

const actions = {
  // 申办方登录
  async LoginSponsor({ commit }, userInfo) {
    commit("SET_LOADING", true);
    try {
      const res = await api().sponsor.login.login({
        username: userInfo.username.trim(),
        password: userInfo.password,
        code: userInfo.code,
        uuid: userInfo.uuid,
        sysType: 2,
      });
      window.location.href = `${getAppUrl(
        "sponsor"
      )}/#/setToken?token=${encodeURIComponent(res.token)}`;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // SMO 登录
  async LoginSmo({ commit }, userInfo) {
    commit("SET_LOADING", true);
    try {
      const res = await api().smo.login.login({
        username: userInfo.username.trim(),
        password: userInfo.password,
        code: userInfo.code,
        uuid: userInfo.uuid,
        smoMenuType: userInfo.smoMenuType,
      });
      window.location.href = `${getAppUrl(
        "smo"
      )}/#/setToken?token=${encodeURIComponent(res.token)}`;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  // 运营商 登录
  async LoginAgent({ commit }, userInfo) {
    commit("SET_LOADING", true);
    try {
      const res = await api().agent.login.login({
        ...userInfo,
      });
      window.location.href = `${getAppUrl(
        "agent"
      )}/#/setToken?token=${encodeURIComponent(res.data.token)}`;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  /**
   * 第一步：获取该账号可登录的机构列表
   * 返回 Array<{ site_id, site_name, site_host }>
   */
  async FetchInstitutionSites(_, username) {
    const res = await institutionLoginApi.getSiteList(username);
    return res.data || [];
  },

  /**
   * 第二步：携带 site_id 真正登录，成功后跳转
   */
  async LoginInstitution({ commit }, { username, password, site_id }) {
    commit("SET_LOADING", true);
    try {
      const res = await institutionLoginApi.login({
        username,
        password,
        site_id,
      });
      const token = res.data?.userinfo?.token;
      window.location.href = `${INSTITUTION_APP_URL}/#/setToken?token=${encodeURIComponent(
        token
      )}&platform=ys-gate`;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default { namespaced: true, state, mutations, actions };
